/**
 * Header Component
 * Handles header interactions and sticky behavior
 */

document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.header');
  
  if (!header) return;

  // Sticky header on scroll
  let lastScroll = 0;
  const headerHeight = header.offsetHeight;

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;

    if (currentScroll > headerHeight) {
      header.classList.add('header--scrolled');
    } else {
      header.classList.remove('header--scrolled');
    }

    lastScroll = currentScroll;
  });

  // Desktop submenu hover
  const menuItems = document.querySelectorAll('.header__menu-item');
  
  menuItems.forEach(item => {
    const submenu = item.querySelector('.header__submenu');
    
    if (submenu) {
      item.addEventListener('mouseenter', () => {
        submenu.style.display = 'block';
        submenu.style.opacity = '0';
        setTimeout(() => {
          submenu.style.opacity = '1';
        }, 10);
      });

      item.addEventListener('mouseleave', () => {
        submenu.style.opacity = '0';
        setTimeout(() => {
          submenu.style.display = 'none';
        }, 200);
      });
    }
  });
});
